import Vue from "vue";
import Store from "@/store";
import { EventBus } from "@/bus/eventbus.js";
import { ConfiguratorFormController } from "@/controller";

function trackVirtualPageView(path, title) {
  const matomo = Vue.prototype.$matomo;
  if (!matomo) return;
  matomo.setCustomUrl(window.location.origin + path);
  matomo.setDocumentTitle(title);
  matomo.trackPageView();
  // Heatmap & Session Recording only re-checks its URL rules on a real
  // navigation - for SPA virtual pageviews it must be triggered manually.
  window._paq && window._paq.push(["HeatmapSessionRecording::trackPageView"]);
}

export function trackEvent(category, action, name, value) {
  const matomo = Vue.prototype.$matomo;
  if (!matomo) return;
  matomo.trackEvent(category, action, name, value);
}

// The configurator has no vue-router routes for its wizard steps/result/detail
// views - they are all driven by Vuex state - so vue-matomo's router
// integration can't see them. This mirrors that navigation as virtual
// pageviews instead.
export function initMatomoTracking() {
  Store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case "SET_ACTIVE_FORM_STEP":
        // setStep() dispatches SET_EDIT_FORM_ON_RESULT right after this mutation
        // when entering edit-on-result mode, so that transition is tracked from
        // the SET_EDIT_FORM_ON_RESULT case below instead - here we only handle
        // the initial wizard flow and step changes made while already editing.
        if (!ConfiguratorFormController.restoringSteps && (!state.app.displayResult || state.app.editFormOnResult)) {
          const step = state.app.activeFormStep + 1;
          if (state.app.editFormOnResult) {
            trackVirtualPageView(
              `/configurator/result/edit/step-${step}`,
              `Configurator - Result - Edit - Step ${step}`
            );
          } else {
            trackVirtualPageView(
              `/configurator/step-${step}`,
              `Configurator - Step ${step}`
            );
          }
        }
        break;
      case "SET_DISPLAY_RESULT":
        if (state.app.displayResult) {
          trackVirtualPageView("/configurator/result", "Configurator - Result");
        }
        break;
      case "SET_EDIT_FORM_ON_RESULT":
        if (state.app.editFormOnResult) {
          const step = state.app.activeFormStep + 1;
          trackVirtualPageView(
            `/configurator/result/edit/step-${step}`,
            `Configurator - Result - Edit - Step ${step}`
          );
        } else {
          trackVirtualPageView("/configurator/result", "Configurator - Result");
        }
        break;
      case "SET_SHOW_DETAIL":
        if (state.app.showDetail) {
          trackVirtualPageView("/configurator/result/detail", "Configurator - Result - Detail");
        }
        break;
      case "SET_DETAIL_PAGE":
        if (state.app.showDetail && state.app.detailPage) {
          trackVirtualPageView(
            `/configurator/result/detail/${state.app.detailPage}`,
            `Configurator - Result - Detail - ${state.app.detailPage}`
          );
        }
        break;
    }
  });

  EventBus.$on("onShowGdpr", () => {
    trackVirtualPageView("/privacy-policy", "Privacy Policy");
  });
}
